import { useInfiniteQuery } from '@tanstack/react-query';
import api from '../../../services/api';
import { IGetStoresPaginated } from './types';

const QUERY_KEY_GET_STORES_PAGINATED = 'QUERY_KEY_GET_STORES_PAGINATED';

export function useGetStoresPaginated(
    name?: string,
    shopmanagerIds?: string[],
    perPage = 10,
    enabled = true,
) {
    const getStoresPaginated = async (page: number) => {
        const { data }: { data: IGetStoresPaginated } = await api.get(
            '/stores/paginated',
            {
                params: {
                    page,
                    perPage,
                    name,
                    shopmanagerIds,
                },
            },
        );

        return {
            data: data?.data ?? [],
            nextPage: page + 1,
        };
    };

    return useInfiniteQuery({
        queryKey: [
            QUERY_KEY_GET_STORES_PAGINATED,
            name,
            shopmanagerIds,
            perPage,
        ],
        queryFn: ({ pageParam = 1 }) => getStoresPaginated(pageParam),
        getNextPageParam: (lastPage) => {
            if (lastPage.data.length < perPage) return undefined;
            return lastPage?.nextPage;
        },
        refetchOnWindowFocus: false,
        enabled,
    });
}
